// ===========================================================================
// CDCI — Clinical Documentation & Charge Intelligence
// Constantes del módulo (docs/modulos/BillingV2/02_CDCI_Descripcion_Modulo.md)
//
// NOTA: catálogos hardcodeados mientras el backend expone los maestros mdm.*
// (mdm.TAB_AMD_LOCATIONS, APPOINTMENT_TYPE, APPOINTMENT_STATUS — Paso 1 del
// roadmap). Cuando existan, estos se cargan vía GET api/amd/locations etc.
// ===========================================================================

export const CDCI_BASE_PATH = "/cdci";

// Estados de cita (futuro maestro mdm APPOINTMENT_STATUS)
export const APPT_STATUS = {
  SCHEDULED:   { key: "SCHEDULED",   label: "Scheduled",    tone: "muted" },
  CONFIRMED:   { key: "CONFIRMED",   label: "Confirmed",    tone: "info" },
  CHECKED_IN:  { key: "CHECKED_IN",  label: "Checked in",   tone: "info" },
  IN_ROOM:     { key: "IN_ROOM",     label: "In room",      tone: "warn" },
  COMPLETED:   { key: "COMPLETED",   label: "Completed",    tone: "ok" },
  NO_SHOW:     { key: "NO_SHOW",     label: "No show",      tone: "crit" },
  CANCELLED:   { key: "CANCELLED",   label: "Cancelled",    tone: "muted" },
};

// Tipos de cita con color (futuro maestro getappttypes)
export const APPT_TYPES = {
  AWV:        { key: "AWV",        label: "Annual Wellness", color: "#1B5FA8" },
  FOLLOW_UP:  { key: "FOLLOW_UP",  label: "Follow Up",       color: "#0F6E6E" },
  TELEHEALTH: { key: "TELEHEALTH", label: "Telehealth",      color: "#7B5EA7" },
  HOSP_FU:    { key: "HOSP_FU",    label: "Hospital D/C FU", color: "#B5760A" },
  SICK:       { key: "SICK",       label: "Sick Visit",      color: "#C0392B" },
};

// Ciclo de vida de la nota del encuentro (entidad Note — Paso 4 del roadmap)
export const NOTE_STATUS = {
  NOT_STARTED: { key: "NOT_STARTED", label: "Not started", tone: "muted" },
  DRAFT:       { key: "DRAFT",       label: "Draft",       tone: "warn" },
  COMPLETE:    { key: "COMPLETE",    label: "Complete",    tone: "info" },
  SIGNED:      { key: "SIGNED",      label: "Signed",      tone: "ok" },
};

// Ciclo de vida de los cargos del encuentro (entidad Charge — Paso 5)
export const CHARGE_STATUS = {
  NOT_CAPTURED: { key: "NOT_CAPTURED", label: "Not captured", tone: "muted" },
  DRAFT:        { key: "DRAFT",        label: "Draft",        tone: "warn" },
  CAPTURED:     { key: "CAPTURED",     label: "Captured",     tone: "ok" },
};

// Pasos del journey del médico (§2 del documento maestro)
export const JOURNEY_STEPS = [
  { key: "schedule", label: "Schedule" },
  { key: "context",  label: "Patient Context" },
  { key: "note",     label: "Documentation" },
  { key: "charges",  label: "Charge Capture" },
  { key: "sign",     label: "Sign & Close" },
];

// Tabs del workspace del encuentro
export const ENCOUNTER_TABS = {
  CONTEXT: "context",
  NOTE: "note",
  CHARGES: "charges",
  SIGN: "sign",
};
